var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99203 10.3L8.33203 8.88L10.672 10.3L10.052 7.64L12.132 5.84L9.39203 5.62L8.33203 3.1L7.27203 5.62L4.53203 5.84L6.61203 7.64L5.99203 10.3ZM0.332031 16.5V2.1C0.332031 1.66 0.488698 1.28333 0.802031 0.97C1.11536 0.656667 1.49203 0.5 1.93203 0.5H14.732C15.172 0.5 15.5487 0.656667 15.862 0.97C16.1754 1.28333 16.332 1.66 16.332 2.1V11.7C16.332 12.14 16.1754 12.5167 15.862 12.83C15.5487 13.1433 15.172 13.3 14.732 13.3H3.53203L0.332031 16.5ZM2.85203 11.7H14.732V2.1H1.93203V12.6L2.85203 11.7Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/reviews.f18ff8fc6f936c774df64534bf4d9f7e.svg";
export { ForwardRef as ReactComponent };